import store from '@/store'
import router from '@/router'


export const defaultFontSize = () => {
  var d = window.document.createElement('div');
  d.style.width = '1rem';
  d.style.display = "none";
  var head = window.document.getElementsByTagName('head')[0];
  head.appendChild(d);
  var defaultFontSize = parseFloat(window.getComputedStyle(d, null).getPropertyValue('width'));
  d.remove();
  return defaultFontSize;
}

export const adoptdevice = (designWidth, rem2px,defaultFontSize) => {
  var head = window.document.getElementsByTagName('head')[0];
  document.documentElement.style.fontSize = window.innerWidth / designWidth * rem2px / defaultFontSize * 100 + '%';
  var x=window.innerWidth / designWidth * rem2px / defaultFontSize * 100 + '%';
  var st = document.createElement('style');
  var portrait = "@media screen and (min-width: "+window.innerWidth+"px) {html{font-size:"+ x + "}}"
  // var landscape = "@media screen and (min-width: "+window.innerHeight+"px) {html{font-size:"+ ((window.innerHeight/(designWidth/rem2px)/defaultFontSize)*100) +"%;}}"
  st.innerHTML = portrait;
  head.appendChild(st);
}


export const isOver720 = () => {
  function  getInnerWidth(){
    let width = window.innerWidth;
    if (width >= 720) {
     store.commit('OVER720', true);
    }else{
     store.commit('OVER720', false);
    }
  }
  getInnerWidth();
  window.onresize = function(){
    getInnerWidth();
  }
}

//解析URL参数
export const parseQuery = query => {
  if (query.indexOf('?') != -1){
    let searchList = query.split('?');
    console.log(searchList);
    let arr = [];
    if (query.indexOf('?#') != -1 && searchList.length > 2) {
      let tokenArr = searchList.find((item,index) => {
        return item.indexOf('token') > -1
      })
      console.log(tokenArr)
      arr = tokenArr.split('&');
    //   arr=searchList[2].split('&');
    // }else{
    //   console.log('?')
    //   arr=searchList[1].split('&');
    }
    console.log(arr);
    let result={}; //声明变量为对象，加{}
    for (let i = arr.length - 1; i >= 0; i--) {
      let arr2=arr[i].split('=');
      result[arr2[0]]=arr2[1];
    }
    console.error(result);
    return result;
  }
};

//判断是否有缓存
export const isUserCookie = (cookieuserid,path)=>{
  // let cookieuserid = getCookie('ZDGZUSERID');
 if (cookieuserid === undefined || cookieuserid == null || cookieuserid == "" || cookieuserid == 'undefined' ){
    console.log('isUserCookie==false')
    let now = new Date();
    now.setTime(now.getTime() + 10 * 60 * 1000); //记录十分钟的路径cookie
    // if (path.indexOf('#')!= -1 ) {
    //   var currentPath = '#'+path.split('#')[1];
    // }
    console.log('currentPath'+path);
    document.cookie = "pathInfo=" + path + ";expires=" + now.toGMTString();
    router.push({ path: '/oauth' })
 }
}

// 读取cookie
export const getCookie = c_name =>{
  if (document.cookie.length>0){
    let c_start=document.cookie.indexOf(c_name + "=")
    if (c_start!=-1){
      c_start=c_start + c_name.length+1
      let c_end=document.cookie.indexOf(";",c_start)
      if (c_end==-1) c_end=document.cookie.length
      return document.cookie.substring(c_start,c_end)
    }
  }
  return ""
}


//正则读取cookie
// function getCookie(name)
// {          //匹配字段
//     var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");

//     if(arr=document.cookie.match(reg))

//         return (arr[2]);
//     else
//         return null;
// }


// 设置cookie
export const setCookie = (name,info) =>{
    let validity = 0.1;
    let now = new Date();
    now.setTime(now.getTime() + validity * 24 * 60 * 60 * 1000);
    document.cookie = name+ "=" + info + ";expires=" + now.toGMTString();
}

// 删除cookie
export const delCookie = name =>{
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval=getCookie(name);
  if(cval!=null){
    document.cookie= name + "="+cval+";expires="+exp.toGMTString();
  }
}

// 删除所有cookie
export const delAllcookie = name =>{
  console.log("删除缓存")
  var strCookie=document.cookie;
  var arrCookie=strCookie.split("; ");
  for(var i=0;i <arrCookie.length;i++){
    var arr=arrCookie[i].split("=");
    if(arr.length>0)
    // 删除单个cookie方法
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval=getCookie(arr[0]);
    if(cval!=null){
      document.cookie= arr[0] + "="+cval+";expires="+exp.toGMTString();
    }
  }
}

//金钱分段，
export const formatmoney = (moneystr) => {
  // console.log(moneystr)
  moneystr=moneystr.split("");
  moneystr.reverse();
  for(var i=0;i<moneystr.length;i=i+4){
    moneystr.splice(i,0,",")
  }
  moneystr=moneystr.slice(1);
  moneystr.reverse()
  moneystr=moneystr.join("");
  return moneystr
};
// 日期格式化
export const formatDate = (date,pattern) => {
  // console.log(date,pattern)
  var date = new Date(date);
  function format(m){
    var n=m+1;
    if (n<10) {
      return "0"+n;
    }
    else{
      return n
    }
  }
  var year=date.getFullYear(),
      month=format(date.getMonth()),
      day=format(date.getDate()-1),
      hour=format(date.getHours()-1),
      minute=format(date.getMinutes()-1),
      second=format(date.getSeconds()-1);
  switch(pattern){
    case "yyyy": return year;
    break;
    case "yyyy-MM": return year+" - "+month;
    break;
    case "yyyy/MM": return year+" / "+month;
    break;
    case "yyyy-MM-dd": return year+"-"+month+"-"+day;
    break;
    case "yyyy/MM/dd": return year+"/"+month+"/"+day;
    break;
    case "yyyy-MM-dd HH": return year+"-"+month+"-"+day+" "+hour;
    break;
    case "yyyy/MM/dd HH": return year+"/"+month+"/"+day+" "+hour;
    break;
    case "yyyy-MM-dd HH:mm": return year+"-"+month+"-"+day+" "+hour+":"+ minute;
    break;
    case "yyyy/MM/dd HH:mm": return year+"/"+month+"/"+day+" "+hour+":"+ minute;
    break;
    case "yyyy-MM-dd HH:mm:ss": return year+"-"+month+"-"+day+" "+hour+":"+ minute+":"+second;
    break;
    case "yyyy/MM/dd HH:mm:ss": return year+"/"+month+"/"+day+" "+hour+":"+ minute+":"+second;
    break;
  }
}
export const createGDMap = () => {
  console.log("createGDMap function in util")
  // 创建高德地图
  let createMap = () => {
    const promise = new Promise(function (resolve, reject) {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://webapi.amap.com/maps?v=1.3&key=1f648c12a2709a14b0e79551fdc5f791'   // 高德地图
      document.body.appendChild(script)
      if (script.nodeName === 'SCRIPT') {
        resolve()
      } else {
        reject(new Error('Could not script image at ' + script.src))
      }
    })
    return promise
  }
  createMap().then(function () {
    console.log('读取高德地图成功')
    // 加載當前的ip定位
  }).catch(function (error) {
    // 处理 getJSON 和 前一个回调函数运行时发生的错误
    console.log('发生错误！', error)
  })
}

export const clearAlltimer = () => {
  var end = setTimeout(function(){},1);
  // var start = (end -100)>0?end-100:0;
  for(var i=0;i<=end;i++){
      clearTimeout(i);
  }
  console.log("清除所有定时器"+end);
}


// 微信授权
export const doAuthReady = (vm, cb) => {
  var code = Utils.getQueryString('code')
  var user = Utils.STORE.getStore(Utils.STORE.user)
  console.log('openid: ' + user.openid)
  // 如果本地存在 openid
  if (user.openid) {
    // 检查服务器有无更新
    this.checkService(user.openid, function (isExist) {
      if (isExist) {
        this.copyUser(vm, user, cb)
      } else {
        Utils.STORE.setStore(Utils.STORE.user, {})
        this.checkAuth()
      }
    }.bind(this))
  } else if (code) {
    // 授权回来拿到 code 去后台获取用户信息
    this.getUserInfo(code).then(function (res) {
      var resUser = res.data.extraInfo
      this.copyUser(vm, resUser, cb)
      Utils.STORE.setStore(Utils.STORE.user, resUser)
    }.bind(this))
  } else {
    // 去授权
    this.checkAuth()
  }
}

// 微信分享配置
export const wxShareConfig = (title, desc, link, imgUrl) => {
  // console.log('wxShare Config')
  wx.ready(() => {
    // “分享给朋友”
    wx.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function () { },
      fail: function (res) {
        console.log(res)
      }
    })
    // “分享到朋友圈”
    wx.onMenuShareTimeline({
      title: title,
      link: link,
      imgUrl: imgUrl,
      success: function () { },
      fail: function (res) {
        console.log(res)
      }
    })

    // 分享到QQ
    wx.onMenuShareQQ({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function () { },
      fail: function (res) {
        console.log(res)
      }
    })
    // 分享到腾讯微博
    wx.onMenuShareWeibo({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function () { },
      fail: function (res) {
        console.log(res)
      }
    })
    // 分享到QQ空间
    wx.onMenuShareQZone({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function () { },
      fail: function (res) {
        console.log(res)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/util.js